"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardsActions = exports.dashboardsSliceReducer = exports.dashboardsSlice = exports.defaultDashboardsSliceState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const constants_1 = require("../../constants");
const normalized_entity_1 = require("../../normalized-entity");
const table_config_1 = require("../../shared/table-config");
exports.defaultDashboardsSliceState = {
    priorityTasksTable: Object.assign(Object.assign({}, table_config_1.defaultTableState), { sort: {
            key: 'task',
            direction: 0 /* SortDirection.Ascending */,
        } }),
};
exports.dashboardsSlice = (0, toolkit_1.createSlice)({
    name: `${constants_1.ENRICH_AI_PREFIX}${normalized_entity_1.NormalizedEntityPrefix.Catalog}dashboards`,
    initialState: exports.defaultDashboardsSliceState,
    reducers: {
        setPriorityTasksTableFilter: (state, action) => {
            state.priorityTasksTable = (0, table_config_1.applyTableFilter)(state.priorityTasksTable, action.payload.value);
        },
        setPriorityTasksTableSearch: (state, action) => {
            state.priorityTasksTable = (0, table_config_1.applyTableSearch)(state.priorityTasksTable, action.payload.value);
        },
        setPriorityTasksTableSort: (state, action) => {
            state.priorityTasksTable = (0, table_config_1.applyTableSort)(state.priorityTasksTable, action.payload.value);
        },
        setPriorityTasksTableRowSize: (state, action) => {
            state.priorityTasksTable = (0, table_config_1.applyRowSize)(state.priorityTasksTable, action.payload.value);
        },
        setPriorityTasksTablePageSize: (state, action) => {
            state.priorityTasksTable = (0, table_config_1.applyPageSize)(state.priorityTasksTable, action.payload.value);
        },
        setPriorityTasksTableDynamicColumns: (state, action) => {
            state.priorityTasksTable = (0, table_config_1.applyDynamicTableColumns)(state.priorityTasksTable, action.payload.value);
        },
    },
});
exports.dashboardsSliceReducer = exports.dashboardsSlice.reducer;
const sliceActions = exports.dashboardsSlice.actions;
// Wrapper actions that add catalogId to payload for normalizedEntityReducer routing
// normalizedEntityReducer checks for payload.id and routes the action to that catalog's reducer
exports.dashboardsActions = {
    setPriorityTasksTableFilter: (catalogId, filter) => (sliceActions.setPriorityTasksTableFilter({ id: catalogId, value: filter })),
    setPriorityTasksTableSearch: (catalogId, search) => (sliceActions.setPriorityTasksTableSearch({ id: catalogId, value: search })),
    setPriorityTasksTableSort: (catalogId, sort) => (sliceActions.setPriorityTasksTableSort({ id: catalogId, value: sort })),
    setPriorityTasksTableRowSize: (catalogId, rowSize) => (sliceActions.setPriorityTasksTableRowSize({ id: catalogId, value: rowSize })),
    setPriorityTasksTablePageSize: (catalogId, pageSize) => (sliceActions.setPriorityTasksTablePageSize({ id: catalogId, value: pageSize })),
    setPriorityTasksTableDynamicColumns: (catalogId, dynamicColumns) => (sliceActions.setPriorityTasksTableDynamicColumns({ id: catalogId, value: dynamicColumns })),
};
